import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { AiOutlineLoading } from "react-icons/ai";
import { useGenerateContentContext } from "../../../context/GenerateContentContext";

const GenerateFullContentData = ({ type, structure, onGenerated, setShowModal }) => {
  const [prompt, setPrompt] = useState("");
  const [isError, setIsError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { generateFullContentData } = useGenerateContentContext();

  const sendPrompt = async () => {
    if (!prompt || prompt === "") setIsError(true);
    setLoading(true);
    setIsError(false);

    const response = await generateFullContentData({
      data: {
        message: `${prompt}. The time format is "HH:mm", "HH:mm:ss" or "HH:mm:ss.SSS" where HH is 00-23, mm is 00-59, ss is 00-59, and SSS is 000-999. ALWAYS HAVE A DEFAULT VALUE FOR ALL THE FIELDS. IF YOU HAVE NO INFO FOR A FIELD, USE "none"`,
        numberOfContents: 1,
        contentType: type,
        structure,
      },
    });

    setLoading(false);

    if (response && response?.length > 0) {
      onGenerated(response[0]);
      setShowModal(false);
    }
  };

  const btnBase =
    "inline-flex items-center justify-center gap-2 px-4 py-2.5 rounded-lg border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2";
  const btnPrimary =
    "bg-blue-600 text-white border-blue-600 hover:bg-blue-500 focus-visible:ring-blue-500 disabled:opacity-60 disabled:cursor-not-allowed";
  const btnNeutral =
    "bg-white text-slate-700 border-slate-200 hover:bg-slate-50";

  return (
    <div className="fixed inset-0 z-[2147483647]">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[2px]" />
      <div className="absolute inset-0 flex items-start justify-center p-4 sm:p-6">
        <div className="w-full max-w-xl bg-white rounded-2xl border border-slate-200 shadow-2xl overflow-hidden">
          <div className="sticky top-0 z-10 flex items-center justify-between px-5 py-4 border-b bg-white/95 backdrop-blur">
            <span className="text-lg font-semibold text-slate-900 capitalize">
              Generate {type}
            </span>
            <button
              onClick={() => setShowModal(false)}
              className={`${btnBase} ${btnNeutral} p-2 !px-3`}
              aria-label="Close"
            >
              <FaTimes className="text-base" />
            </button>
          </div>

          <div className="px-5 pt-4 pb-2 max-h-[62vh] overflow-y-auto">
            <label htmlFor="gen-prompt" className="block text-sm font-medium text-slate-700 mb-2">
              Enter your prompt
            </label>
            <textarea
              id="gen-prompt"
              rows={5}
              value={prompt}
              onChange={(e) => {
                setIsError(false);
                setPrompt(e.target.value);
              }}
              aria-invalid={isError ? "true" : "false"}
              className={`w-full rounded-xl border px-4 py-3 text-sm outline-none placeholder:text-slate-400 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${isError ? "border-red-600" : "border-slate-300"
                }`}
              placeholder={`Describe what the ${type?.toLowerCase?.() || "content"} should include...`}
            />
            {isError ? (
              <div className="mt-2 text-xs text-red-600">Please enter a prompt.</div>
            ) : null}
            <div className="mt-3 text-xs text-slate-500">{prompt.length} characters</div>
          </div>

          <div className="px-5 py-5 border-t bg-white">
            <button
              disabled={loading}
              onClick={sendPrompt}
              className={`${btnBase} ${btnPrimary} w-full justify-center`}
            >
              {loading ? <AiOutlineLoading className="animate-spin text-base" /> : null}
              <span className="capitalize">Generate {type}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GenerateFullContentData;
